import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef, useState } from 'react';
import { styled } from 'styled-components';
import { createDefaultImageReader, createDefaultImageWriter, createDefaultShapePreprocessor, locale_en_gb, plugin_crop, plugin_crop_locale_en_gb, setPlugins, } from '@hivebrite/pqina-pintura';
import { PinturaEditor } from '@hivebrite/pqina-react-pintura';
import { Box } from '@design-system/box';
import { HistoryActions } from './Actions/History';
import { NavigationActions } from './Actions/Navigation';
import { PixelIndicator } from './Components/PixelIndicator';
import '@hivebrite/pqina-pintura/pintura.css';
export const CropAndZoom = ({ image, imageCropAspectRatio, initialImageState, onCancel, onSave, saveLabel, withHistoryActions, withNavigationActions, withPixelIndicator, }) => {
    const editorRef = useRef(null);
    const [eventHandlers, setEventHandlers] = useState([]);
    const registerEventHandler = useCallback((handler) => {
        setEventHandlers((prevHandlers) => [...prevHandlers, handler]);
    }, []);
    setPlugins(plugin_crop);
    const handleEvent = (type, detail) => {
        for (const handler of eventHandlers) {
            handler(type, detail);
        }
        if (type === 'ready' && initialImageState && editorRef.current) {
            editorRef.current.editor.imageState = initialImageState;
        }
    };
    const editorConfig = {
        cropEnableRotationInput: false,
        cropEnableZoomAutoHide: false,
        enableToolbar: true,
        handleEvent,
        imageCropAspectRatio,
        imageReader: createDefaultImageReader(),
        imageWriter: createDefaultImageWriter(),
        locale: Object.assign(Object.assign({}, locale_en_gb), plugin_crop_locale_en_gb),
        shapePreprocessor: createDefaultShapePreprocessor(),
    };
    const handleConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const imageWriterOutput = yield ((_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor.processImage());
        if (!imageWriterOutput) {
            return;
        }
        onSave({
            imageState: imageWriterOutput.imageState,
            initialImage: imageWriterOutput.src,
            modifiedImage: imageWriterOutput.dest,
        });
    });
    return (_jsxs(Box, { "data-testid": "crop-and-zoom-wrapper", flexDirection: "column", height: "100%", width: "100%", children: [withHistoryActions && (_jsx(ActionWrapper, { alignSelf: "right", children: _jsx(HistoryActions, { editorRef: editorRef, registerEventHandler: registerEventHandler }) })), _jsxs(Wrapper, { children: [_jsx(StyledPinturaEditor, Object.assign({ ref: editorRef, src: image }, editorConfig)), withPixelIndicator && (_jsx(PixelIndicator, { registerEventHandler: registerEventHandler }))] }), withNavigationActions && (_jsx(ActionWrapper, { children: _jsx(NavigationActions, { cancelTestId: "crop-component-cancel-button", onCancel: onCancel, onSave: handleConfirm, saveLabel: saveLabel, saveTestId: "crop-component-confirm-button" }) }))] }));
};
const ActionWrapper = styled(Box).attrs(() => ({
    justifyContent: 'flex-end',
})) ``;
const Wrapper = styled(Box).attrs(() => ({
    flex: 1,
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    pb: 2,
    pt: 5,
    width: '100%',
})) `
  position: relative;
`;
const StyledPinturaEditor = styled(PinturaEditor) `
  * {
    font-family: inherit !important;
    font-size: inherit !important;
  }

  .pintura-editor {
    --color-foreground: 81, 134, 236 !important;
    --color-preview-outline: 81, 134, 236 !important;
  }

  .PinturaUtilHeader {
    display: none;
  }

  .PinturaRectManipulator {
    border-radius: 0 !important;
    --size: 10px !important;
  }

  .PinturaUtilMain {
    cursor: grab;
  }

  .PinturaNavTools {
    display: none !important;
    height: 0 !important;
    padding: 0 !important;
  }

  .PinturaRangeInput {
    cursor: grab;
  }

  .PinturaUtilFooter {
    background: white;
    padding: 0 !important;

    > div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }

  .PinturaUtilPanel {
    padding-bottom: 0 !important;
  }
`;
//# sourceMappingURL=CropAndZoom.js.map